export const getIsDisabled = userType => {
  if (!userType || userType === 'VENDOR') return true
  return false
}
